import { Routes } from '@angular/router';
// import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { View } from '@lib/core';
//import { OciProductDetailComponent } from './oci-product-detail/oci-product-detail.component';

export const MY_ADMIN_HOME = `${View.CLIENT}/my-admin`;

export const OCI_ROUTES: Routes = [];
